import { useVersionChangeCell } from "../context/VersionChangesContext";
export function VersionChangeMark({
  nurseId,
  day,
}: {
  readonly nurseId: string;
  readonly day: number;
}) {
  const cell = useVersionChangeCell(nurseId, day);
  if (!cell) return null;
  return (
    <span
      role="img"
      className="pointer-events-none absolute inset-[2px] z-[3] rounded-md border-2 border-orange-500"
      data-testid="roster-version-change-cell"
      aria-label={`${cell.kind === "added" ? "새로 추가" : cell.kind === "removed" ? "근무 전부 삭제" : "변경"}: ${cell.before?.shift_id || "빈 칸"} → ${cell.after?.shift_id || "빈 칸"}`}
    >
      <span
        className={
          cell.kind === "removed"
            ? "absolute inset-0 flex items-center justify-center rounded bg-zinc-100 text-xs text-muted-foreground"
            : "absolute -top-2 left-0 max-w-full rounded bg-white px-0.5 text-[9px] leading-3 text-orange-800"
        }
      >
        {cell.before ? <del>{cell.before.shift_id}</del> : "+"}
      </span>
    </span>
  );
}
